import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { fmtDateTime, inr, STATUS_COLORS } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");
  const [payment, setPayment] = useState("all");
  const [q, setQ] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    const params = {};
    if (status !== "all") params.status = status;
    if (payment !== "all") params.payment = payment;
    if (q) params.q = q;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    api.get("/admin/orders", { params }).then((r) => setOrders(r.data)).catch(() => {});
  }, [status, payment, q, dateFrom, dateTo]);

  return (
    <div className="space-y-4" data-testid="admin-orders-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight">Orders</h1>
      <div className="flex flex-wrap gap-3">
        <Input placeholder="Search order # / customer…" value={q} onChange={(e) => setQ(e.target.value)} className="w-56 bg-white" data-testid="order-search-input" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-40 bg-white" data-testid="order-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            {["placed", "packed", "shipped", "delivered", "cancelled"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={payment} onValueChange={setPayment}>
          <SelectTrigger className="w-40 bg-white" data-testid="order-payment-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All payments</SelectItem>
            <SelectItem value="razorpay">Razorpay</SelectItem>
            <SelectItem value="cod">COD</SelectItem>
          </SelectContent>
        </Select>
        <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="w-40 bg-white" data-testid="order-date-from" />
        <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="w-40 bg-white" data-testid="order-date-to" />
      </div>

      <div className="bg-white border border-neutral-200 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-left text-[11px] font-mono uppercase tracking-widest text-neutral-500 border-b border-neutral-200">
              <th className="p-3">Order</th><th className="p-3">Customer</th><th className="p-3">Payment</th>
              <th className="p-3">Status</th><th className="p-3 text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-neutral-100 hover:bg-neutral-50" data-testid={`admin-order-row-${o.order_number}`}>
                <td className="p-3">
                  <Link to={`/admin/orders/${o.id}`} className="font-mono font-medium hover:text-brand">{o.order_number}</Link>
                  <p className="text-xs text-neutral-400">{fmtDateTime(o.created_at)}</p>
                </td>
                <td className="p-3">
                  <p>{o.customer?.name}</p>
                  <p className="text-xs text-neutral-400">{o.customer?.email}</p>
                </td>
                <td className="p-3">
                  <span className="font-mono text-xs uppercase">{o.payment_method}</span>
                  <p className={`text-xs ${o.payment_status === "paid" ? "text-emerald-700" : "text-amber-700"}`}>{o.payment_status}</p>
                </td>
                <td className="p-3"><span className={`text-[11px] font-mono uppercase px-2 py-0.5 ${STATUS_COLORS[o.status] || "bg-neutral-100"}`}>{o.status}</span></td>
                <td className="p-3 text-right font-medium">{inr(o.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="p-6 text-center text-sm text-neutral-500" data-testid="no-orders-admin">No orders match.</p>}
      </div>
    </div>
  );
}
